import React, { Component } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Container from "@material-ui/core/Container";
import Slide from "@material-ui/core/Slide";
import logo from "./assets/images/JioLogo.png";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsCondition from "./TermsCondition";
import ScrollToTop from "./ScrollToTop";
import { HashRouter, Switch, Route, Link, Redirect } from "react-router-dom";
import "./App.css";

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default function App(props) {
  return (
    <React.Fragment>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar>
          <Toolbar>
            {/* <Typography variant="h6">Scroll to Hide App Bar</Typography> */}
            <div>
              <img className="jio-logo" src={logo} alt="jio logo" />
            </div>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
      <Container>
        <HashRouter>
          <ScrollToTop />
          <Switch>
            <Route exact path="/">
              <Redirect to="/terms-conditions" />
            </Route>
            <Route exact path="/terms-conditions">
              <TermsCondition />
            </Route>
            <Route exact path="/privacy-policy">
              <PrivacyPolicy />
            </Route>
            <Route path="*">
              <h1>Page Not Found</h1>
            </Route>
          </Switch>
          <footer>
            <div className="footer-links">
              <span>
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </span>
              <span id="privacy-policy">
                <Link to="/privacy-policy">Privacy Policy</Link>
              </span>
            </div>
            <p className="copy-right">
              Copyright © {new Date().getFullYear()} Reliance Retail Ltd. All
              rights reserved.
            </p>
          </footer>
        </HashRouter>
      </Container>
    </React.Fragment>
  );
}
